import React, { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Loading from '../../../../Loading/loading';
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { AuthContext } from "../../../../Header/auth - context";
import { useSelector } from "react-redux";

const Dokumenti = ({ filesDB, zavedenaDB }) => {
  const { t } = useTranslation();
  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const company = useSelector(state => state.company);

  const [documents, setDocuments] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);

  useEffect(() => {
    const docArray = [];

    if (filesDB) {
      Object.entries(filesDB).forEach(([key, value]) => {
        if (value && value !== "") {
          const paths = value.split('|').filter(p => p.trim() !== '');
          paths.forEach((singlePath, index) => {
            docArray.push({
              name: paths.length > 1 ? `${getDocumentName(key)} (${index + 1})` : getDocumentName(key),
              path: getDocumentLocation(singlePath.trim().replace(/\\/g, '/')),
              vrsta: t('admin.dokPrilog')
            });
          });
        }
      });
    }

    /* Dokumenta zavedena kroz Štampu dokumentacije: naziv nosi i redni broj,
       jer isti zaposleni može imati više dokumenata istog tipa (npr. novi
       ugovor posle raskida). */
    (zavedenaDB || []).forEach(d => {
      if (!d.putanja) return;
      docArray.push({
        name: `${d.TipDokumenta} (${d.redni_broj}) - ${d.zavedeni_broj}`,
        path: getDocumentLocation(String(d.putanja).replace(/\\/g, '/')),
        vrsta: t('admin.dokZavedeno')
      });
    });

    setDocuments(docArray);
  }, [filesDB, zavedenaDB, t]);


 const getDocumentLocation = (normalizedPath) => {
  // Remove full C:/Dokumenta/ from path
  const relativePath = normalizedPath.replace(/^C:\/Dokumenta\//, '');
  const encodedPath = encodeURI(relativePath); // Encode spaces, etc.
  return `${process.env.REACT_APP_BACKEND_URL}/files/${encodedPath}`;
};
  const getDocumentName = (field) => {
    switch (field) {
      case 'uploadedFileLK': return `Lična karta`;
      case 'uploadedFileVD': return `Vozačka dozvola`;
      case 'uploadedFileT': return `Tahograf`;
      case 'uploadedFileO': return `Osiguranje`;
      case 'uploadedFileHealth': return `Zdravstvena knjižica`;
      case 'uploadedFileADR': return `ADR sertifikat`;
      case 'uploadedFileDEF': return `Bezbednost na radu`;
      case 'uploadedFilePASS': return `Pasoš`;
      case 'uploadedFileVIZA': return `Viza`;
      case 'uploadedFileCPC': return `CPC`;
      case 'uploadedFileCPCP1': return `CPC P1`;
      case 'uploadedFileCPCP2': return `CPC P2`;
      case 'uploadedFileCPCP3': return `CPC P3`;
      case 'uploadedFileCPCP4': return `CPC P4`;
      case 'uploadedFileCPCP5': return `CPC P5`;
      case 'foreignUploadedFileLK': return `Lična karta (strana)`;
      case 'foreignUploadedFileVD': return `Vozačka dozvola (strana)`;
      case 'foreignUploadedFilePASS': return `Pasoš (strani)`;
      case 'foreignUploadedFileVIZA': return `Viza (strana)`;
      case 'contractFile': return `Ugovor`;
      default: return `Nema dokumenta`;
    }
  };
  const previewBodyTemplate = (rowData) => {
    return (
      <Button
        label={t('admin.pregledaj')}
        icon="pi pi-eye"
        className="p-button-text"
        onClick={() => window.open(`${rowData.path}`, '_blank')}
      />
    );
  };
 

  return (
    <div id="zaposleni_dokumenti">
      <Toast ref={toast} />
      <div className="zaposleni_table">
        <DataTable
          className="stavke-tabela"
          header={(
            <div className="export-buttons fakture-stavke-header">
              <span />
              <input type="search" className="p-inputtext p-component"
                     onInput={(e) => setGlobalFilter(e.target.value)}
                     placeholder={t('common.search')} />
            </div>
          )}
          value={documents}
          paginator
          rows={10}
          first={first}
          globalFilter={globalFilter}
          onPage={(e) => setFirst(e.first)}
        >
          <Column field="name" header={t('admin.nazivDokumenta')} sortable></Column>
          <Column field="vrsta" header={t('admin.dokVrsta')} sortable></Column>
          <Column body={previewBodyTemplate} header={t('fakture.pregled')}></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default Dokumenti;
